export const INITIAL_VALUES = {
  name: '',
};
